export default {
  getNeighborhoods: state => state.items,
  getNeighborhoodId: (state, getters) => {
    let neighborhood = window.localStorage.getItem('neighborhood')
    if (!neighborhood) return false
    return JSON.parse(neighborhood).id || false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/neighborhoods/getters.js